export const typography = {
  // TODO
};
